var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.5C21 16.299 16.299 21 10.5 21C4.70101 21 0 16.299 0 10.5C0 4.70101 4.70101 0 10.5 0C16.299 0 21 4.70101 21 10.5ZM1.91561 10.5C1.91561 15.241 5.75897 19.0844 10.5 19.0844C15.241 19.0844 19.0844 15.241 19.0844 10.5C19.0844 5.75897 15.241 1.91561 10.5 1.91561C5.75897 1.91561 1.91561 5.75897 1.91561 10.5Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.81836C9.97276 3.81836 9.54541 4.24572 9.54541 4.7729V10.9457C9.54541 10.9457 9.54541 11.1945 9.66635 11.3817C9.7473 11.5404 9.87349 11.6784 10.0393 11.7741L14.4491 14.3202C14.9057 14.5837 15.4895 14.4273 15.753 13.9707C16.0166 13.5142 15.8602 12.9304 15.4036 12.6668L11.4545 10.3868V4.7729C11.4545 4.24573 11.0272 3.81836 10.5 3.81836Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecent);
export default __webpack_public_path__ + "static/media/recent.f6bdbf4f976655a80f1454c6de3a12d3.svg";
export { ForwardRef as ReactComponent };